import { HtmlIterator } from 'components/sharpr/html/htmlIterator/HtmlIteratorClass';

export function htmlUnmixContentFilter() {
	'ngInject';
	const protocol = window.karmaTestProtocol || document.location.protocol;
	const protocolMap = {
		'https:': 'http:',
		'http:': 'https:',
	};
	const fromProtcol = protocolMap[protocol];
	if (!fromProtcol) {
		// not a protocol we care about (e.g. file)
		return k => k;
	}
	const find = new RegExp(`^<(img|audio|video)([\\s\\S]+src=(?:"|'|\`|))${fromProtcol}([\\s\\S]+)$`, 'i');
	const replace = `<$1$2${protocol}$3`;
	const unmixer = html => html.replace(find, replace);
	const iterator = new HtmlIterator(unmixer);
	return html => iterator.map(html);
}
